import { useEffect } from 'react';

const SITE = 'https://www.jenmaconcept.com';

const setMeta = (sel, attr, val) => {
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement(sel.startsWith('link') ? 'link' : 'meta');
    const m = sel.match(/\[(\w+)="([^"]+)"\]/);
    el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, val);
};

export function useSeo(title, description, path) {
  useEffect(() => {
    document.title = `${title} | JENMA Concept`;
    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
    }
    setMeta('meta[property="og:title"]', 'content', `${title} | JENMA Concept`);
    setMeta('link[rel="canonical"]', 'href', `${SITE}${path}`);
    setMeta('meta[property="og:url"]', 'content', `${SITE}${path}`);
  }, [title, description, path]);
}
